/** Subset of google.maps.GeocoderAddressComponent used by Places Autocomplete. */
export type GoogleAddressComponent = {
  long_name: string
  short_name: string
  types: string[]
}

/**
 * Derive a display "city" for office locations from Places `address_components`.
 * Rural Portugal (and similar) often omit `locality`; `administrative_area_level_2`
 * is usually the municipality (concelho). Order aligns with Geocoder's
 * `Geocoder::Result::Google#city`, plus `postal_town` (UK/Ireland) and explicit
 * `sublocality_level_*` types.
 */
export function pickCityFromGoogleAddressComponents(components: GoogleAddressComponent[]): string | null {
  const priorityTypes = [
    "locality",
    "postal_town",
    "sublocality_level_1",
    "sublocality_level_2",
    "sublocality",
    "administrative_area_level_3",
    "administrative_area_level_2"
  ]

  for (const type of priorityTypes) {
    const found = components.find((c) => c.types.includes(type))
    if (found?.long_name) return found.long_name
  }
  return null
}
